import React, { useState, useEffect, useRef } from 'react';
//import { handleInputChange } from 'react-select/dist/declarations/src/utils';

function ABText(props) {

  const { label, name, id, fieldId, isRequired, errId, caseId, divClass, value, caseCheckId, drugIndex, isReadonly, maxLength } = props;

  //console.log(value , name);

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    [name]: null,
  });

  useEffect(() => {

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

  }, [value]);

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    props.inputText([{ "name": name, "value": e.target.value, "fieldId": fieldId, "isRequired": isRequired, "drugIndex": drugIndex, "err_id": errId, "caseId": caseId, "caseCheckId": caseCheckId, "isReadonly": isReadonly }]);


  }

  // const handleChange = (selectedOption) => {

  //   props.inputText({ "name": name, "value": selectedOption.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": `err-${fieldId}` });
 
  //   //setKeyword(selectedOption.name);

  // };

  let elementClass = 'col-sm-4 col-md-12 col-xl-4';
  if(divClass){
    elementClass = divClass;
  }

  function validate(event) {
    var theEvent = event || window.event;
  
    // Handle paste
    if (theEvent.type === 'paste') {
        key = event.clipboardData.getData('text/plain');
    } else {
    // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
    }
    var regex = /[0-9]|\./;
    if( !regex.test(key) ) {
      theEvent.returnValue = false;
      if(theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  function validateAddress(event){
    var theEvent = event || window.event;
  
    // Handle paste
    if (theEvent.type === 'paste') {
        key = event.clipboardData.getData('text/plain');
    } else {
    // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
    }
    var regex =  /[^a-zA-Z0-9\-\/]/;
    if( !regex.test(key) ) {
      theEvent.returnValue = false;
      if(theEvent.preventDefault) theEvent.preventDefault();
    }
}
console.log(name,"value",value);
  return (
    <>
      <div className={elementClass}>
        <div className="form-group">
          <div className="floating-label has-left-icon">
          {/* {value == '' ? (
          <>  
           {console.log("hello")}
           {name=="pin_code"?<input type="text" onKeyPress={(event)=>validate(event)} className="form-control" name={name} id={id} onChange={handleFloatingLabels}/>:<input type="text" className="form-control" name={name} id={id} onChange={handleFloatingLabels}/>}
            
            <label htmlFor={props.id ? props.id : ''} className={formData[name] && 'focused'}>{label}{isRequired == 1 && <sup className="text-danger">*</sup>}</label>
          </>
          ) : (
          <>
          
          {name=="pin_code"?
            <input type="text" className="form-control" onKeyPress={(event)=>validate(event)} readonly={isReadonly} name={name} id={id} value={formData[name] ? formData[name]:""} onChange={handleFloatingLabels} maxLength={maxLength}  />:<input type="text" className="form-control" readonly={isReadonly} name={name} id={id} value={formData[name] ? formData[name]:""} onChange={handleFloatingLabels}  />}
            <label htmlFor={props.id ? props.id : ''} className={(value!='' && value!=null) ? 'focused':''}>{label}{isRequired == 1 && <sup className="text-danger">*</sup>}</label>
          </>
           )}  */}
            <input type="text" className="form-control" name={name} id={id} onChange={handleFloatingLabels} autoComplete="off" value={formData[name] ? formData[name]:""}/>
            <label htmlFor={props.id ? props.id : ''} className={formData[name] && 'focused'}>{label}{isRequired == 1 && <sup className="text-danger">*</sup>}</label>
          </div>
          <p className="err text-danger" id={errId}></p>  
        </div>
      </div>

      {/* <div className={elementClass}>
        <div className="form-group">
          <div className="floating-label has-left-icon">
            <input type="text" className="form-control" name={name} id={id} drugIndex={drugIndex} onChange={handleFloatingLabels} autoComplete="off" value={formData[name]}/>
            <label htmlFor={props.id ? props.id : ''} className={formData[name] && 'focused'}>{label}{isRequired == 1 && <sup className="text-danger">*</sup>}</label>
          </div>
          <p className="err text-danger" id={errId}></p>  
        </div>
      </div> */}

    </>
  );
}

export default ABText;
